import dayjs from "dayjs";
import { useId } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import { useTranslation } from "react-i18next";

export function DeliveryDates({
	from,
	to,
	onChange,
	disabled = false,
}: {
	from: string;
	to: string;
	onChange: (range: { from: string; to: string }) => void;
	disabled?: boolean;
}) {
	const { t } = useTranslation("translation", { keyPrefix: "webhookHealth.deliveries" });
	const id = useId();

	return (
		<div className="flex flex-wrap gap-3">
			{(["from", "to"] as const).map((side) => (
				<div key={side} className="w-44">
					<label className="text-xs text-text-meta" htmlFor={`${id}-${side}`}>
						{t(side)}
					</label>
					<Datepicker
						asSingle
						disabled={disabled}
						displayFormat="DD MMM YYYY"
						i18n="en"
						inputId={`${id}-${side}`}
						inputClassName="input-styles w-full cursor-pointer rounded-[10px] px-3 py-2 text-sm text-text disabled:cursor-not-allowed"
						useRange={false}
						value={{
							startDate: (side === "from" ? from : to)
								? dayjs(side === "from" ? from : to).toDate()
								: null,
							endDate: (side === "from" ? from : to)
								? dayjs(side === "from" ? from : to).toDate()
								: null,
						}}
						onChange={(value) =>
							onChange({
								from,
								to,
								[side]: value?.startDate ? dayjs(value.startDate).format("YYYY-MM-DD") : "",
							})
						}
					/>
				</div>
			))}
		</div>
	);
}
